import { logger } from "@otto-ec/global-resources/debug";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
const ROOT_SCOPE = "heureka.leafcutter";

type LogFn = (...data: unknown[]) => void;

export interface Log {
  trace: LogFn;
  debug: LogFn;
  info: LogFn;
  warn: LogFn;
  error: LogFn;
  /**
 *
 */
  isEnabled: () => boolean;
}

type Level = "trace" | "debug" | "info" | "warn" | "error";

/**
 *
 *
 */
export function createLog(module: string, root: string = ROOT_SCOPE): Log {
  const scopeName = `${root}.${module}`;
  let delegate: ReturnType<typeof logger> | undefined;

  /*                                                                                                                */
  const resolve = () => {
    delegate ??= logger(scopeName) ?? undefined;
    return delegate;
  };

  const forward =
    (level: Level): LogFn =>
    (...data) => {
      resolve()?.[level](...data);
    };

  return {
    trace: forward("trace"),
    debug: forward("debug"),
    info: forward("info"),
    warn: forward("warn"),
    error: forward("error"),
    isEnabled: () => resolve()?.isEnabled() ?? false,
  };
}
